// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"0c4e2a42","899":"9da1b89a"}[chunkId] + ".chunk.js";
};